import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatIdentityUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const identityUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        identity_attrs,
        identity_name,
        identity_type,
        user_auth,
        user_id,
        ...rest
    } = extractProperties<NinchatIdentityUpdatedEvent>(action.payload)

    isEmpty(rest)

    if (user_id === state.user_id) {
        const ref = state.user_identities[identity_type] ?? {}

        ref[identity_name] = identity_attrs

        if (user_auth) {
            state.user_auth = user_auth
        }
    }
}
